import React from 'react';
import $ from 'jquery';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import { getContentPath } from '../../util/contentPath';
import './index.less';
import { WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class ToolBar extends React.Component<any, any>{

    changeZoom=(v)=>{
        const { ganttStore } = this.props;
        ganttStore.timelinekey=v;
        ganttStore.previousId=ganttStore.id;
        $('#workSpace_'+ganttStore.getGanttId).trigger('zoomChange' + v);
    }

    render() {
        const { ganttStore } = this.props;
        return <div className="ganttButtonBar noprint">
            <div className="title" title={ganttStore.baseInfo&&ganttStore.baseInfo.ganttname}>{ganttStore.baseInfo&&ganttStore.baseInfo.ganttname}</div>
            <div className="buttons">
                <div>
                    <i onClick={()=>{print();}} title={getLabel('257','打印')} className="icon-coms-Print" style={{color:'#777',display:'inline-block',transform: 'scale(2)'}}/>
                    <span className="ganttButtonSeparator"></span>
                    {ganttStore.canCreate&&<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@4mej0e`} style={{borderBottomRightRadius: '0',borderTopRightRadius: '0', padding:'5px 8px'}} type="primary" onClick={()=>{
                            ganttStore.openDialog(getContentPath('/spa/cube/index.html#/main/cube/card?type=1&modeId='+ganttStore.baseInfo.modeid+'&formId='+ganttStore.baseInfo.formid));
                        }}>{getLabel('365','新建')}</Button>}
                    {ganttStore.canSave&&<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@zexzl0`} style={{borderBottomLeftRadius: '0',borderTopLeftRadius: '0', padding:'5px 8px'}} onClick={()=>{
                        ganttStore.save();
                    }}>{getLabel('30986','保存')}</Button>}
                </div>
                <div className="time-line">
                    <Button.Group ecId={`${this && this.props && this.props.ecId || ''}_Button.Group@kwbkjv`}>
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@pq2qfw`} type={ganttStore.timelinekey=='1M'?"primary":"ghost"} onClick={()=>{
                            this.changeZoom('1M');
                        }}>{getLabel('390','日')}</Button>
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@1kczte`} type={ganttStore.timelinekey=='2w'?"primary":"ghost"} onClick={()=>{
                            this.changeZoom('2w');
                        }}>{getLabel("1926", "周")}</Button>
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@x7htyb`} type={ganttStore.timelinekey=='1y'?"primary":"ghost"} onClick={()=>{
                            this.changeZoom('1y');
                        }}>{getLabel('33452','月')}</Button>
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@lygtqt`} type={ganttStore.timelinekey=='2Q'?"primary":"ghost"} onClick={()=>{
                            this.changeZoom('2Q');
                        }}>{getLabel('18280','季')}</Button>
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@e9va5j`} type={ganttStore.timelinekey=='2y'?"primary":"ghost"} onClick={()=>{
                            this.changeZoom('2y');
                        }}>{getLabel('26577','年')}</Button>
                    </Button.Group>
                </div>
                <div style={{marginLeft:'10px',color:'red'}}>{ganttStore.loadingtip}</div>
                <div className="right-color-type">
                    {ganttStore.colorDatas.map(item=>{
                        return <span>
                            <span className="color-span" style={{ backgroundColor: item.color }}></span>
                            <span className="color-label">{item.name}</span>
                        </span>
                    })}
                </div>
            </div>


        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/ToolBar.tsx